import { Box, Stack, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Components.Shared.Filters;

type Props = {
  dateFrom?: Date;
  dateTo?: Date;
  onDateFromChange: (date: Date | undefined) => void;
  onDateToChange: (date: Date | undefined) => void;
};

export const DateRangeFilterDropdown = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack direction="row" gap={2} flexWrap="wrap">
      <Box flex={1} minWidth={140}>
        <Typography variant="body2" mb={1} fontWeight={500}>
          {t(PageResources.DateFrom)}
        </Typography>
        <DatePicker
          value={dateFrom ?? null}
          maxDate={dateTo}
          onChange={(date) => onDateFromChange(date ?? undefined)}
          slotProps={{ textField: { size: "small", fullWidth: true } }}
        />
      </Box>
      <Box flex={1} minWidth={140}>
        <Typography variant="body2" mb={1} fontWeight={500}>
          {t(PageResources.DateTo)}
        </Typography>
        <DatePicker
          value={dateTo ?? null}
          minDate={dateFrom}
          maxDate={new Date()}
          onChange={(date) => onDateToChange(date ?? undefined)}
          slotProps={{ textField: { size: "small", fullWidth: true } }}
        />
      </Box>
    </Stack>
  );
};
